import AjaxClass from './Validation/ajaxClass';
import FormValidate from './Validation/formValidateClass';
import MessageHandler from './Validation/messageHandler';
export default function login(){
    $("#login-form").on('submit', function (e) {
        e.preventDefault();
        const Loader = document.getElementById("loading-forms")
        let form = $(this);
        let fields = form.serializeArray();
        let validation = new FormValidate(fields);
        const modalSuccess = document.getElementById('success-message-forms');
        const modalSuccessDescription = document.querySelector('#success-message-forms .description');
        const modalError = document.getElementById('error-message-forms');
        const modalDescription = document.querySelector('#error-message-forms .description');

        validation.validateAll(fields);
        let error = validation.hasError();
        
        MessageHandler.removeAllFormFailMessages()
        // let terms = $("#checkbox").prop('checked') == true;
        // if (!error && !terms){
        //     error = true
        //     const id = $("#checkbox").attr('idError')
        //     MessageHandler.showFailMessage(id, true);
        //     return false;
        // }

        if (error) {
            let errorMessageId = validation.getErrorId();
            MessageHandler.showFailMessage(errorMessageId, true);
        }

        if (error == false) {
            Loader.classList.add("open-modal");
            if ($(this).attr('disabled') == 'disabled') {
                return false;
            }
            $(this).attr('disabled', 'disabled');
            let type = 'POST';
            let url = $(this).attr('action');
            let dataType = 'json';
            
            class Login extends AjaxClass {
                successFunction(data, form) {
                    Loader.classList.remove("open-modal");
                    if (data.status == true) {
                        $('#login-form').trigger("reset");
                        $("#login-form").removeAttr('disabled');
                        if (data.urlRedirect) {
                            window.location = data.urlRedirect;
                            return;
                        } else {
                            modalSuccess.classList.add("open-modal");
                            modalSuccessDescription.innerHTML = data.txt;
                        }
                    } else {
                        modalDescription.innerHTML = data.txt;
                        modalError.classList.add("open-modal");
                        $("#login-form").removeAttr('disabled');
                    }
                };
                errorFunction(xhr, textStatus, errorThrown) {
                    Loader.classList.remove("open-modal");
                    modalDescription.innerHTML = "Ocorreu um erro. Tente novamente mais tarde.";
                    modalError.classList.add("open-modal");
                    $("#login-form").removeAttr('disabled');
                };
            }
            let ajax = new Login(form, type, url, dataType, form.serialize());
            ajax.send();
        }

        return false;
    });
}
